import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CMSApiService, CreateSettingDTO } from 'features/cms/api/cms-api.service';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { eventsettings } = CMSApiService();

export const useSetting = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CreateSettingDTO) => {
            return eventsettings(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data: any) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 1 && data?.tabsSettings==null) {
                    message.success(ResponseMessage)
                } 
            },

        },
    );
};
